// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__yV5jW","goback":"Header_goback__mVILS","goback_wrapper":"Header_goback_wrapper__1Fkkd","title":"Header_title__DHSkK"};